<template>
  <el-form :model="query" :inline="true" size="small">
    <el-form-item label="子账号：">
      <el-input v-model="query.keywords" placeholder="姓名/手机号" clearable style="width:160px" />
    </el-form-item>
    <el-form-item label="时间类型：">
      <el-select v-model="query.timeType" style="width:110px">
        <el-option label="新增" :value="1" />
        <el-option label="审核通过" :value="2" />
        <el-option label="回访" :value="3" />
        <el-option label="市场核实" :value="4" />
      </el-select>
    </el-form-item>
    <el-form-item label="日期区间：">
      <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" />
    </el-form-item>
    <el-form-item label="状态：">
      <el-select v-model="query.status" clearable placeholder="全部" style="width:120px">
        <el-option label="待回访" :value="1" />
        <el-option label="回访正常" :value="2" />
        <el-option label="异常已关闭" :value="3" />
        <el-option label="待市场核实" :value="4" />
        <el-option label="市场核实完成" :value="5" />
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="handleDownload">导出</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import childFollowupApi from '@/api/cust/childFollowup'

/**
 * 子账号回访导出（REQ-2026-601171），异步任务走 sys_task 套路
 * 从列表页「导出」跳转过来时会带上当前筛选（含单条流转记录导出时的 followupId），这里做预填
 */
export default {
  name: 'ExportChildFollowup',
  data() {
    const routeQuery = this.$route.query || {}
    return {
      dateRange: routeQuery.startTime && routeQuery.endTime ? [routeQuery.startTime.slice(0, 10), routeQuery.endTime.slice(0, 10)] : null,
      query: {
        keywords: routeQuery.keywords || '',
        timeType: routeQuery.timeType ? Number(routeQuery.timeType) : 3,
        status: routeQuery.status !== undefined && routeQuery.status !== '' ? Number(routeQuery.status) : undefined,
        followupId: routeQuery.followupId || undefined
      }
    }
  },
  methods: {
    buildQuery() {
      const q = { ...this.query }
      if (this.dateRange && this.dateRange.length === 2) {
        q.startTime = `${this.dateRange[0]} 00:00:00`
        q.endTime = `${this.dateRange[1]} 23:59:59`
      }
      return q
    },
    handleDownload() {
      return this.$common.confirm('是否确认导出').then(() => {
        return childFollowupApi.exportExcel(this.buildQuery())
      }).then((res) => {
        if (res.code === '0') {
          setTimeout(() => this.$emit('created'), 500)
        }
      }).catch((error) => {
        if (error !== 'cancel') this.$common.showNotifyError(error)
      })
    }
  }
}
</script>
